module.exports = __webpack_public_path__ + "img/warning.60048627.svg";